import React from 'react';
import { Flex, Heading, Text } from '@chakra-ui/react';

interface PageHeaderProps {
  title: string;
  canEdit?: boolean;
  description?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description }) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="flex-start"
      mb="10px"
      minHeight="75px"
      flexFlow="column"
    >
      <Heading size="lg" fontSize={25} fontWeight={500}>
        {title}
      </Heading>
      {description && (
        <Text fontSize={16} color="gray.500">
          {description}
        </Text>
      )}
    </Flex>
  );
};

export default PageHeader;
